import { render, staticRenderFns } from "./SelectPhoto.vue?vue&type=template&id=52b23a50&"
import script from "./SelectPhoto.vue?vue&type=script&lang=js&"
export * from "./SelectPhoto.vue?vue&type=script&lang=js&"
import style0 from "./SelectPhoto.vue?vue&type=style&index=0&id=52b23a50&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports